/** Small "Recent bekeken" badge shown on deal cards the visitor has already viewed. */
export default function RecordedBadge() {
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-1 text-[10px] font-semibold uppercase tracking-wide"
      style={{
        backgroundColor: "#E7F4FF",
        color: "#0A8DE9",
      }}
    >
      Recent bekeken
    </span>
  );
}
